import styled from 'styled-components';

const sizeProp = ({ size = 30 }) => size;

const CircularImage = styled.img`
    border-radius: 50%;
    object-fit: cover;
    height: ${sizeProp}px;
    width: ${sizeProp}px;
`;

export default CircularImage;


// WEBPACK FOOTER //
// ./src/components/CircularImage.js